module.exports = __webpack_public_path__ + "static/media/noFilterIcon.122dfb1e.svg";